<template>
  <div class="relative flex flex-col">
    <editor-tabs
      :labels="$store.state.datasets.pushData"
      :current="$store.state.indexingLanguage"
      :on-click="
        index => {
          $store.commit('setIndexingLanguage', { index })
          defaultPushDataTab = 0
          defaultInstallAPIClientTab = 0
        }
      "
    />
    <div class="relative h-full">
      <div class="absolute pin flex flex-col w-full">
        <code-snippet
          class="snippet-small flex flex-col"
          title="Install API client"
          :content="$store.getters.getPushDataDataset.datasets[0]"
          :collapsed="isStepCompleted"
          :tab.sync="defaultInstallAPIClientTab"
        />
        <code-snippet
          class="flex flex-col"
          title="Push Data"
          :content="
            $store.getters.getPushDataDataset.datasets[1][
              $store.getters.getPickDatasetsDataset.id
            ]
          "
          :collapsed="isStepCompleted"
          :tab.sync="defaultPushDataTab"
        />
        <code-snippet
          v-show="!isStepCompleted"
          class="snippet-run relative flex flex-col"
          title="View Results"
          :copy-button="false"
        >
          <template slot="header">
            <pop-over class="absolute -ml-216 z-50"
              >Run the code before proceeding to the next step.</pop-over
            >
          </template>
          <div class="flex justify-center">
            <run-code-button :is-running="isRunning" :on-click="runCode" />
          </div>
        </code-snippet>
        <code-snippet
          v-show="isStepCompleted"
          class="flex flex-col bg-east-bay"
          title="View Results"
          :copy-button="false"
          :scrollable="false"
        >
          <result-set
            class="flex flex-col min-h-0"
            :uploaded-records-amount="$store.state.uploadedRecordsAmount"
            placeholder="Search the data that we just pushed"
            :indices="indices"
            :notification="true"
          />
        </code-snippet>
      </div>
    </div>
  </div>
</template>

<script>
import algoliasearch from 'algoliasearch'

import { checkRecords } from '@/scripts/CheckAlgoliaIndex'

import EditorTabs from '@/components/EditorTabs'
import CodeSnippet from '@/components/CodeSnippet'
import PopOver from '@/components/PopOver'
import RunCodeButton from '@/components/RunCodeButton'
import ResultSet from '@/components/ResultSet'

import track from '@/scripts/Track'

export default {
  components: {
    EditorTabs,
    CodeSnippet,
    PopOver,
    RunCodeButton,
    ResultSet
  },
  data() {
    return {
      isRunning: false,
      defaultPushDataTab: 0,
      defaultInstallAPIClientTab: 0
    }
  },
  methods: {
    fetchDataset() {
      return fetch(
        `https://raw.githubusercontent.com/algolia/doc-code-samples/master/onboarding/datasets/${this.$store.getters.getPickDatasetsDataset.id}.json`
      ).then(response => response.json())
    },
    runCode() {
      if (!this.isRunning && this.$store.getters.isUserLoggedIn) {
        this.startPush()
        this.fetchDataset().then(response => {
          this.$store.commit('setUploadedRecordsAmount', {
            amount: response.length
          })
          this.runPush(...this.$store.getters.getCredentials, response)
            .then(() => {
              this.finishPush()
            })
            .catch(err => {
              console.log(err) // eslint-disable-line no-console
            })
        })
      } else {
        this.startPush()
        this.fetchDataset().then(response => {
          this.$store.commit('setUploadedRecordsAmount', {
            amount: response.length
          })
          this.fakeFinishPush()
        })
      }
      track({
        message: 'Clicked Run the Code',
        code: 'docs.onboarding.run.code',
        extraData: {
          source: 'Push Data'
        }
      })
    },
    startPush() {
      this.isRunning = true
    },
    finishPush() {
      this.isRunning = false
      this.$store.commit('setStepAsCompleted', { step: 1 })
    },
    fakeFinishPush() {
      setTimeout(() => {
        this.finishPush()
      }, 1000)
    },
    listenForPush(appId, apiKey, indexName) {
      return checkRecords(algoliasearch(appId, apiKey).initIndex(indexName))
    },
    runPush(appId, apiKey, indexName, objects) {
      return algoliasearch(appId, apiKey)
        .initIndex(indexName)
        .saveObjects(objects, {
          autoGenerateObjectIDIfNotExist: true
        })
    }
  },
  computed: {
    isStepCompleted() {
      return this.$store.state.steps[parseInt(this.$route.name, 10) - 1]
        .completed
    },
    indices() {
      return [
        {
          name: `${this.$store.getters.getIndexName}_not_configured`
        }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (!this.isStepCompleted && this.$store.getters.isUserLoggedIn) {
        this.fetchDataset().then(response => {
          this.$store.commit('setUploadedRecordsAmount', {
            amount: response.length
          })
          this.listenForPush(...this.$store.getters.getCredentials)
            .then(() => {
              this.startPush()
              this.fakeFinishPush()
            })
            .catch(err => {
              console.log(err) // eslint-disable-line no-console
            })
        })
      }
    })
  }
}
</script>
